<template>
  <v-dialog v-model="dialog" max-width="1400px" persistent scrollable>
    <v-card>
      <v-card-title>
        <h3 style="margin-bottom: 30px" v-if="create">Zimmer anlegen</h3>
        <h3 style="margin-bottom: 30px" v-else>Zimmer bearbeiten</h3>

        <v-flex xs12>
          <v-tabs v-model="tab.value" grow background-color="teal lighten-5">
            <v-tabs-slider color="primary"/>
            <v-tab v-for="tab in tab.tabs" :key="tab.label" :style="getErrorStyle(tab)">
              {{ tab.label }}
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-form style="min-height: 400px" v-model="form" ref="roomForm" lazy-validation>
          <v-flex xs12 class="text-sm-left" v-if="dialog">

            <v-tabs-items v-model="tab.value" v-if="room !== undefined">
              <v-tab-item v-for="tab in tab.tabs" :key="tab.value">
                <v-card flat v-if="tab.value === 0">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md5>
                      <v-text-field
                        v-model="room.name"
                        :rules="rules"
                        label="Zimmername"
                        required/>
                      <v-text-field :disabled="room.id !== undefined"
                                    v-model="room.externalId"
                                    :rules="rules"
                                    label="Zimmercode (Casablanca ID)"
                                    required/>
                      <v-checkbox
                        v-model="room.ignore"
                        label="Zimmer ignorieren"
                      />
                    </v-flex>
                    <v-flex xs12 sm12 md6 offset-md1>
                      <v-layout wrap row>
                        <v-flex xs3>
                          <v-text-field
                            v-model="room.minOccupancy"
                            :rules="rules"
                            type="number"
                            label="Mindestbelegung"
                            required/>
                        </v-flex>
                        <v-flex xs3 offset-xs1>
                          <v-text-field
                            v-model="room.stdOccupancy"
                            :rules="rules"
                            type="number"
                            label="Standardbelegung"
                            required/>
                        </v-flex>
                        <v-flex xs3 offset-xs1>
                          <v-text-field
                            v-model="room.maxOccupancy"
                            :rules="rules"
                            type="number"
                            label="Maximalbelegung"
                            required/>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                            v-model="room.quantity"
                            :rules="rules"
                            type="number"
                            label="Anzahl der Zimmer"
                            required/>
                        </v-flex>
                        <v-flex xs4 offset-xs1>
                          <v-text-field
                            v-model="room.position"
                            :rules="rules"
                            label="Zimmerposition"
                            hint="Nur für interne Auflistung."
                            persistent-hint
                            type="number"
                            required/>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card flat v-if="tab.value === 1">
                  <v-card-text>
                    <base-price-rule :rooms="rooms" :room="room"/>
                  </v-card-text>
                </v-card>
                <v-card flat v-if="tab.value === 2">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12 sm5>
                        <v-select v-model="room.occupancyPaymentMode"
                                  :items="paymentModes"
                                  item-text="label"
                                  item-value="value"
                                  label="Berechnungsmodus"/>
                        <div v-if="room.occupancyRules.length === 0">
                          Belegungspreise wurden noch nicht definiert.
                        </div>
                        <v-list dense v-else>
                          <div v-for="(rule, index) in room.occupancyRules" :key="index">
                            <div style="cursor: pointer;">
                              <v-list-item style="height: 20px !important;min-height: 25px;">
                                <v-list-item-content>Belegung (Personen)</v-list-item-content>
                                <v-list-item-content class="text-sm-right">
                                  <v-edit-dialog
                                    :return-value.sync="rule.occupancy"
                                    lazy>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <div style="display: inline-block;" v-on="on">{{ rule.occupancy }}</div>
                                      </template>
                                      <span>Bearbeiten</span>
                                    </v-tooltip>
                                    <v-text-field
                                      slot="input"
                                      v-model="rule.occupancy"
                                      :rules="rules"
                                      label="Belegung"
                                      single-line
                                      mask="##"
                                    />
                                  </v-edit-dialog>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn icon disabled style="opacity: 0; cursor: pointer; height: 5px">
                                    <v-icon color="red">delete</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                              <v-list-item style="height: 20px !important;min-height: 25px;">
                                <v-list-item-content>
                                  <span v-if="room.occupancyPaymentMode === 'EURO'">
                                    {{ $t('hotel.kognitiv.additionalGuestPrice') }}
                                    <span v-if="room.stdOccupancy > rule.occupancy">(Abschlag)</span>
                                    <span v-else>(Aufschlag)</span>
                                  </span>
                                  <span v-else>Prozent
                                    <span v-if="room.stdOccupancy > rule.occupancy">(Abschlag)</span>
                                    <span v-else>(Aufschlag)</span>
                                  </span>
                                </v-list-item-content>
                                <v-list-item-content class="text-sm-right">
                                  <v-edit-dialog
                                    :return-value.sync="rule.payment"
                                    lazy>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <div v-on="on" style="text-align: right;display: inline-block">
                                          {{ rule.payment }}
                                          <span v-if="room.occupancyPaymentMode === 'EURO'"> €</span>
                                          <span v-else> %</span>
                                        </div>
                                      </template>
                                      <span>Bearbeiten</span>
                                    </v-tooltip>
                                    <v-text-field
                                      slot="input"
                                      v-model="rule.payment"
                                      :rules="rules"
                                      :label="getChildrenValueLabel(room.occupancyPaymentMode)"
                                      single-line
                                    />
                                  </v-edit-dialog>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon ripple style="margin-top: -25px;" v-on="on"
                                             @click="removeRule(room.occupancyRules, index)">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Belegungsregelung löschen</span>
                                  </v-tooltip>
                                </v-list-item-action>
                              </v-list-item>
                            </div>
                            <v-divider/>
                          </div>
                        </v-list>
                        <add-occupancy-rule :room="room"/>
                      </v-flex>
                      <v-flex xs12 sm5 offset-sm2 v-if="otherOccupancyRules.length > 0">
                        <h3>Belegungsregelung von andere Zimmer übernehmen</h3>
                        <v-list dense>
                          <div v-for="occupancyRule in otherOccupancyRules" :key="'occupancyRule_'+occupancyRule.externalId">
                            <v-list-item style="min-height: 30px; height: 35px">
                              <v-list-item-avatar>
                                <v-icon color="primary">label</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>Zimmer: {{ occupancyRule.name }} ({{occupancyRule.externalId}})</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn text color="primary" icon ripple v-on="on" small
                                           @click="addOccupancyRules(occupancyRule)">
                                      <v-icon color="primary">add</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Belegungsregelung übernehmen</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-card flat v-if="tab.value === 3">
                  <v-card-text>
                    <v-layout wrap row v-if="!hotelDTO.noChildren">
                      <v-flex xs12 sm5>
                        <v-select v-model="room.childrenPaymentMode"
                                  :items="paymentModes"
                                  item-text="label"
                                  item-value="value"
                                  label="Berechnungsmodus"/>
                        <div v-if="room.childrenRules.length === 0">
                          {{ $t('hotel.kognitiv.childRulesNotDefinedYet') }}
                        </div>
                        <v-list dense v-else>
                          <div v-for="(rule, index) in room.childrenRules" :key="index">
                            <div style="cursor: pointer;">
                              <v-list-item style="height: 20px !important;min-height: 25px">
                                <v-list-item-content>{{ $t('hotel.kognitiv.childUntil') }}</v-list-item-content>
                                <v-list-item-content class="text-sm-right">
                                  <v-edit-dialog
                                    :return-value.sync="rule.age"
                                    lazy>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <div style="display: inline-block" v-on="on">{{ rule.age }}</div>
                                      </template>
                                      <span>Bearbeiten</span>
                                    </v-tooltip>
                                    <v-text-field
                                      slot="input"
                                      v-model="rule.age"
                                      :rules="rules"
                                      label="Alter"
                                      single-line
                                      mask="##"
                                    />
                                  </v-edit-dialog>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn icon disabled style="opacity: 0; cursor: pointer; height: 5px">
                                    <v-icon color="red">delete</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                              <v-list-item style="height: 20px !important;min-height: 25px">
                                <v-list-item-content>
                                  <span v-if="room.childrenPaymentMode === 'EURO'">{{ $t('hotel.kognitiv.additionalGuestPrice') }}</span>
                                  <span v-else>Prozent</span>
                                </v-list-item-content>
                                <v-list-item-content class="text-sm-right">
                                  <v-edit-dialog
                                    :return-value.sync="rule.price"
                                    lazy>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <div style="display: inline-block" v-on="on">
                                          {{ rule.price }}
                                          <span v-if="room.childrenPaymentMode === 'EURO'"> €</span>
                                          <span v-else> %</span>
                                        </div>
                                      </template>
                                      <span>Bearbeiten</span>
                                    </v-tooltip>
                                    <v-text-field
                                      slot="input"
                                      v-model="rule.price"
                                      :rules="rules"
                                      :label="getChildrenValueLabel(room.childrenPaymentMode)"
                                      single-line
                                      mask="###"
                                    />
                                  </v-edit-dialog>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon ripple style="margin-top: -25px;" v-on="on"
                                             @click="removeRule(room.childrenRules, index)">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Kinderregelung löschen</span>
                                  </v-tooltip>
                                </v-list-item-action>
                              </v-list-item>
                            </div>
                            <v-divider/>
                          </div>
                        </v-list>
                        <add-children-rule :rate-plan="room"/>
                      </v-flex>
                      <v-flex xs12 sm5 offset-sm2 v-if="otherChildrenRules.length > 0">
                        <h3>Kinderregelung von andere Zimmer übernehmen</h3>
                        <v-list dense>
                          <div v-for="childrenRule in otherChildrenRules" :key="'childRule_'+childrenRule.externalId">
                            <v-list-item style="min-height: 30px; height: 35px">
                              <v-list-item-avatar>
                                <v-icon color="primary">label</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>Zimmer: {{ childrenRule.name }} ({{childrenRule.externalId}})</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn text color="primary" icon ripple v-on="on" small
                                           @click="addChildrenRules(childrenRule)">
                                      <v-icon color="primary">add</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Kinderregelung übernehmen</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-alert :value="error.value" color="error" icon="warning" outlined>
          {{ error.message }}
        </v-alert>
        <v-btn color="secondary" text @click.native="dialog = false">{{ $t('cancel') }}</v-btn>
        <v-btn :color="this.error.value ? 'red' : 'primary'" outlined @click="submitRoom()">
          <span v-if="create">{{ $t('hotel.user.add') }}</span>
          <span v-else>Aktualisieren</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import BasePriceRule from './templates/BasePriceRule';
  import AddOccupancyRule from './templates/AddOccupancyRule';
  import AddChildrenRule from '../kognitiv/templates/AddChildrenRule';

  export default {
    props: {
      id: undefined
    },
    components: {
      BasePriceRule, AddChildrenRule, AddOccupancyRule
    },
    data() {
      return {
        error: {
          value: false,
          message: undefined,
          room: false,
          price: false,
          occupancy: false,
          children: false
        },
        paymentModes: [
          { value: 'PERCENT', label: 'Prozent' },
          { value: 'EURO', label: 'Euro' }
        ],
        dialog: false,
        form: undefined,
        room: undefined,
        create: undefined,
        tab: {
          value: 0,
          tabs: [
            { value: 0, label: 'Zimmerdaten'},
            { value: 1, label: 'Mindestpreise (Standardbelegung)' },
            { value: 2, label: 'Belegungspreise (Erwachsene)' },
            { value: 3, label: 'Kinderpreise' },
          ]
        },
        hotelDTO: undefined,
        rooms: [],
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        otherChildrenRules: [],
        otherOccupancyRules: [],
        externalId: undefined,
      };
    },
    mounted() {
      this.globalEvents.$on('manageCasablancaRoom'.concat(this.id), (rooms, room, create, hotelDTO) => {
        this.error.value = false;
        this.tab.value = 0;
        this.resetError();
        this.hotelDTO = hotelDTO;
        this.rooms = rooms;
        this.room = JSON.parse(JSON.stringify(room));
        this.create = create;
        this.otherChildrenRules = this.getOtherChildrenRules();
        this.otherOccupancyRules = this.getOtherOccupancyRules();
        this.dialog = true;
        if (this.create) {
          if (this.$refs.roomForm !== undefined)
            this.$refs.roomForm.reset();
        } else {
          this.externalId = this.room.externalId;
        }
      });
    },
    methods: {
      addOccupancyRules(room) {
        this.room.occupancyRules = JSON.parse(JSON.stringify(room.occupancyRules));
        for(let i = 0; i < this.room.occupancyRules.length; i += 1) {
          const casablancaOccupancyRule = this.room.occupancyRules[i];
          casablancaOccupancyRule.id = null;
        }
        this.room.occupancyPaymentMode = JSON.parse(JSON.stringify(room.occupancyPaymentMode));
      },
      addChildrenRules(room) {
        this.room.childrenRules = JSON.parse(JSON.stringify(room.childrenRules));
        for(let i = 0; i < this.room.childrenRules.length; i += 1) {
          const casablancaChildrenRule = this.room.childrenRules[i];
          casablancaChildrenRule.id = null;
        }
        this.room.childrenPaymentMode = JSON.parse(JSON.stringify(room.childrenPaymentMode));
      },
      getOtherOccupancyRules() {
        const occupancyRules = [];
        for (let i = 0; i < this.rooms.length; i += 1) {
          const casablancaHotelRoom = this.rooms[i];
          if (casablancaHotelRoom.basePrices.length > 0
            && casablancaHotelRoom.externalId !== this.room.externalId) {
            occupancyRules.push({
              name: casablancaHotelRoom.name,
              externalId: casablancaHotelRoom.externalId,
              occupancyPaymentMode: casablancaHotelRoom.occupancyPaymentMode,
              occupancyRules: casablancaHotelRoom.occupancyRules
            });
          }
        }
        return occupancyRules;
      },
      getOtherChildrenRules() {
        const childrenRules = [];
        for (let i = 0; i < this.rooms.length; i += 1) {
          const casablancaHotelRoom = this.rooms[i];
          if (casablancaHotelRoom.basePrices.length > 0
            && casablancaHotelRoom.externalId !== this.room.externalId) {
            childrenRules.push({
              name: casablancaHotelRoom.name,
              externalId: casablancaHotelRoom.externalId,
              childrenPaymentMode: casablancaHotelRoom.childrenPaymentMode,
              childrenRules: casablancaHotelRoom.childrenRules
            });
          }
        }
        return childrenRules;
      },
      getErrorStyle(tab) {
        let style= '';
        if (this.error.value) {
          if (this.error.room && tab.value === 0) {
            style = 'color: red;';
          } else if (this.error.price && tab.value === 1) {
            style = 'color: red;';
          } else if (this.error.occupancy && tab.value === 2) {
            style = 'color: red;';
          } else if (this.error.children && tab.value === 3) {
            style = 'color: red;';
          }
        }
        return style;
      },
      resetError() {
        this.error.room = false;
        this.error.price = false;
        this.error.occupancy = false;
        this.error.children = false;
      },
      getChildrenValueLabel(mode) {
        return mode === 'EURO' ? 'Preis' : 'Prozent';
      },
      removeRule(rules, index) {
        rules.splice(index, 1);
      },
      submitRoom() {
        if (!this.$refs.roomForm.validate()) {
          this.error.message = this.$i18n.t('hotel.kognitiv.requiredFields');
          this.error.value = true;
          this.resetError();
          this.error.room = true;
        } else if (this.room.basePrices.length === 0) {
          this.error.message = 'Es wurden keine Mindestpreise definiert!';
          this.error.value = true;
          this.resetError();
          this.error.price = true;
        } else if ((this.room.maxOccupancy - 1) > this.room.occupancyRules.length &&
          this.room.maxOccupancy !== this.room.stdOccupancy && this.room.minOccupancy !== this.room.stdOccupancy) {
          this.error.message = 'Nicht alle Belegungsregel wurden definiert!';
          this.error.value = true;
          this.resetError();
          this.error.occupancy = true;
        } else if ((this.room.maxOccupancy - 1) < this.room.occupancyRules.length &&
          this.room.maxOccupancy !== this.room.stdOccupancy && this.room.minOccupancy !== this.room.stdOccupancy) {
          this.error.message = 'Es wurden zu viele Belegungsregel definiert!';
          this.error.value = true;
          this.resetError();
          this.error.occupancy = true;
        } else if (this.room.maxOccupancy === this.room.stdOccupancy
          && this.room.minOccupancy === this.room.stdOccupancy
          && this.room.occupancyRules.length > 0) {
          this.error.message = 'Es sollten keine Belegungsregel definiert sein!';
          this.error.value = true;
          this.resetError();
          this.error.occupancy = true;
        } else if (this.idAlreadyExists()) {
          this.error.message = 'Zimmercode existiert bereits!';
          this.error.value = true;
          this.resetError();
          this.error.room = true;
        } else if (this.checkChildRules()) {
          this.error.message = 'Kinderregelungen sollten hier nicht definiert sein!';
          this.error.value = true;
          this.resetError();
          this.error.children = true;
        } else {
          this.globalEvents.$emit('saveCasablancaRoom'.concat(this.id), this.room);
          this.dialog = false;
        }
      },
      idAlreadyExists() {
        for (let i = 0; i < this.rooms.length; i += 1) {
          const room = this.rooms[i];
          if (this.create && room.externalId === this.room.externalId) { // CREATE ROOM
            return true;
          } else if (!this.create
            && this.externalId !== this.room.externalId
            && room.externalId === this.room.externalId) { // EDIT ROOM
            return true;
          }
        }
        return false;
      },
      checkChildRules() {
        return this.room.childrenRules.length > 0
          && this.room.maxOccupancy === this.room.stdOccupancy
          && this.room.minOccupancy === this.room.stdOccupancy
          && (Number(this.room.stdOccupancy) === 1 || Number(this.room.stdOccupancy) === 2);
      }
    }
  };
</script>
